// The available types of product images.
export enum ProductImageTypes {
  UNSPECIFIED = 0,
  BUST = 1,
  MODEL = 2,
}

export interface ProductImage {
  // complete url of the image containg all cdn properties beside width and height as those are dependent on the view
  src: string;
  // explains the content of the image
  description: string;
  // some images contain a background, some do not. The padding is added in the frontend. If we can handle this in the CDN, it could be removed
  isEnclosed: boolean;
  tracker?: ProductImageTracker;
}

export interface ProductImageTracker {
  // eg: bust, model, primary_bust, primary_model
  type: string;
}
